// components/dialogs/CommunicationPreferencesDialog.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface CommunicationPreferencesDialogProps {
  open: boolean;
  onClose: () => void;
  onSkip: () => void;
}

export const CommunicationPreferencesDialog: React.FC<CommunicationPreferencesDialogProps> = ({
  open,
  onClose,
  onSkip,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>⚠️ Communication Preferences Required</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please set all required communication preferences for this customer.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          variant="text"
          onClick={onSkip}
          sx={{ cursor: "pointer", ml: 1 }}
        >
          Skip for now
        </Button>
        <Button
          onClick={onClose}
          color="warning"
          variant="contained"
        >
          Set Preferences
        </Button>
      </DialogActions>
    </Dialog>
  );
};